

















































/* 共通 */
import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* ストア、定数関連 */
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import { KanriConstants } from '../fixed/KanriConstants';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.08.08 [2023F-07] add
 */
@Component
export default class MailOrganizationInfo extends ApiAccessBase {
  // 参照モードかどうか
  private updateAuthority: boolean = false;

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'メール差出人等情報編集';
    // 権限設定
    if (this.checkAuthority(AuthoritiesId.ORG_UPDATE) || this.checkAuthority(AuthoritiesId.ROLE_CYDEEN2_ADMIN)) {
      this.updateAuthority = true;
    } else {
      this.updateAuthority = false;
    }
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['mail_organization_info']);
    // APIアクセス
    this.apiAccess(KanriConstants.ORG_PATH + '/get/mail', Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if (result === Constants.API_RESULT_SUCCES) {
        } else {
          this.updateAuthority = false;
        }
      },
    );
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    if (supervisingModule.IS_MODE_READ) {
      this.back();
    } else {
      if (window.confirm(Message.I0015)) {
        // 排他削除
        this.apiAccess(KanriConstants.ORG_PATH + '/exclusive/delete/mail', Constants.API_METHOD_POST, false, null)
        .then((result) => {
          if (result === Constants.API_RESULT_SUCCES) {
            this.back();
          }
        });
      }
    }
  }
  private back() {
    router.push({ name: 'kanri-top' });
  }

  /**
   * 登録
   */
  private registData() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    // 確認
    if (!window.confirm(Message.I0003)) {
      return;
    }
    this.apiAccess(KanriConstants.ORG_PATH + '/update/mail', Constants.API_METHOD_POST, true, false)
    .then((result) => {
      this.hrefElement('mailOrganizationInfo', -50);
    });
  }
}
